import React from 'react'
import { motion } from 'framer-motion'
import { FiMail, FiArrowUpRight } from 'react-icons/fi'

const Contact = () => {
  return (
    <div id='contact'>
      <motion.div
        className="contactInner"
        initial={{ y: 40, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <p className="section-label">Get in Touch</p>
        <h2 className="contactHeading">
          Have a project in mind?<br />
          <span className="gradient-text">Let's work together.</span>
        </h2>
        <p className="contactDesc">
          I'm always open to discussing new opportunities, freelance projects, or just a friendly chat about technology.
        </p>
        <a href="https://mail.google.com/mail/?view=cm&fs=1&to=manav9330833@gmail.com" target="_blank" rel="noreferrer" className="contactCta">
          <FiMail />
          manav9330833@gmail.com
          <FiArrowUpRight />
        </a>
      </motion.div>
    </div>
  )
}

export default Contact